import { AuthState, AuthTokens } from '@/contracts/store/AuthContracts'
import { UserStructure } from '@/contracts/UserContracts'

export const Auth =
{
    namespaced: true,
    state: (): AuthState => (
    {
        isAuthenticated: false,
        user: {} as UserStructure,
        paymentId: '',
        token: '',
        refreshToken: ''
    }),
    getters:
    {
        isAuthenticated(state: AuthState): boolean
        {
            return state.isAuthenticated
        },
        getUser(state: AuthState): UserStructure
        {
            return state.user
        },
        getPaymentId(state: AuthState): string
        {
            return state.paymentId
        },
        getToken(state: AuthState): string
        {
            return state.token
        },
        getRefreshToken(state: AuthState): string
        {
            return state.refreshToken
        }
    },
    mutations:
    {
        setAuthenticatedUser(state: AuthState, user: UserStructure): void
        {
            state.isAuthenticated = true
            state.user = user
        },
        setTokens(state: AuthState, tokens: AuthTokens): void
        {
            state.token = tokens.accessToken
            state.refreshToken = tokens.refreshToken
        },
        logout(state: AuthState): void
        {
            state.isAuthenticated = false
            state.user = {} as UserStructure
            state.token = ''
            state.refreshToken = ''
        },
        setPaymentId(state: AuthState, id: string): void
        {
            state.paymentId = id
        }
    }
}
